//
// =VIDEO POP-UP
// --------------------------------------------------

const playVideoBtns = document.querySelectorAll(".msdw-play-video");
const msdwPopupVideoWrapper = document.querySelector(
  ".msdw-popup-video-wrapper"
);
const msdwPopupVideoBackDrop = document.querySelector(
  ".msdw-popup-video-backdrop"
);
const msdwPopupVideo = document.getElementById("msdwPopupVideo");
if (document.contains(msdwPopupVideoWrapper)) {
  // OPEN
  playVideoBtns.forEach((playVideoBtn) => {
    playVideoBtn.addEventListener("click", (e) => {
      e.preventDefault();
      const videoUrl = playVideoBtn.getAttribute("data-modal-video");
      msdwPopupVideo.setAttribute("src", videoUrl);
      msdwPopupVideoWrapper.classList.add("msdw-active");
      document.body.classList.add("jws-overflowHidden");
      msdwPopupVideo.muted = false;
      msdwPopupVideo.play();
    });
  });
  // CLOSE
  const closePopUpVideo = () => {
    document.body.classList.remove("jws-overflowHidden");
    msdwPopupVideo.muted = true;
    msdwPopupVideo.pause();
    msdwPopupVideo.currentTime = 0;
    msdwPopupVideoWrapper.classList.remove("msdw-active");
  };
  msdwPopupVideoBackDrop.addEventListener("click", () => {
    closePopUpVideo();
  });
  window.onkeydown = (e) => {
    if (e.keyCode == 27) closePopUpVideo();
  };
}
